//@ts-nocheck

const video = () => {
  const buttons = document.querySelectorAll(".js-video-play");
  if (buttons.length == 0) {
    return;
  }
  buttons.forEach((button) => {
    button.addEventListener("click", () => {
      let videoWrap = button.parentElement;
      let video = videoWrap.querySelector("video");
      video?.setAttribute("controls", true);
      video.play();
      videoWrap?.classList.add("playing");
    });
  });
};

export default video;
